<template>
  <section>
    <el-table
      :data="operateDataLogList"
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>
      <el-table-column  prop="FieldDescription" label="字段描述" width="150"></el-table-column>
      <el-table-column  prop="OldValue" :formatter="isTimeFormat" label="旧值" width="180"></el-table-column>
      <el-table-column  prop="NewValue" :formatter="isTimeFormat" label="新值" width="180"></el-table-column>
      <el-table-column  prop="OperatorName" label="操作人" width="120"></el-table-column>
      <el-table-column  prop="OperatorTime" label="操作时间" width="160"></el-table-column>
      </el-table>
      <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>
  </section>
</template>

<script>
import util from "../../util/date";
import { getOperateDataLogListPage } from "../api/api";

export default {
  data() {
    return {
      operateDataLogList:[],//操作日记列表
      total: 0,
      page: 1,
      pageSize: 10
    };
  },
  props: {
    entityName: {
      type: String,
      default: ''
    },
    entityKey: {
      default: ''
    }
  },
  methods: {
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getOperateDataLogList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getOperateDataLogList();
    },
    isTimeFormat: function(row, column) {
      if (row.DataType === "DateTime"){
        return !row[column.property] || row[column.property] === ""
          ? ""
          : util.formatDate.format(new Date(row[column.property]), "yyyy-MM-dd hh:mm:ss");
      } else if (row.DataType === "" && isNaN(row[column.property]) && !isNaN(Date.parse(row[column.property]))){
        return !row[column.property] || row[column.property] === ""
          ? ""
          : util.formatDate.format(new Date(row[column.property]), "yyyy-MM-dd hh:mm:ss");
      }

      return row[column.property];
    },
    getOperateDataLogList(){
      let _this = this;
      _this.operateDataLogList = [];
      let para = {
        entityName: _this.entityName,
        entityKey: _this.entityKey,
        page: _this.page,
        pageSize: _this.pageSize
      };
      getOperateDataLogListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.operateDataLogList = res.data.response.data;
      });
    }
  },
  mounted() {
    this.page = 1;
    this.getOperateDataLogList();
  }
}
</script>
